import React, { useState } from "react";
import { Link } from "react-scroll";
import logo from "../assets/invetix-logo.png";

const Navbar = ({ openModal }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const handleMenuClose = () => setIsMenuOpen(false);

    return (
        <nav className="bg-navy text-white py-4 sticky top-0 z-50">
            <div className="container mx-auto flex justify-between items-center px-4">
                {/* Logo and Heading */}
                <div className="flex items-center gap-4">
                    <img src={logo} width={50} className="rounded" />
                    <Link className="text-2xl font-bold cursor-pointer"
                        to="hero"
                        smooth={true}
                        duration={500}
                        onClick={() => {
                            handleMenuClose();
                        }}
                    >INVETIX</Link>
                </div>

                {/* Hamburger Menu Button */}
                <button
                    className="sm:hidden text-xl"
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                >
                    ☰
                </button>

                {/* Off-canvas Menu */}
                <div
                    className={`fixed top-0 right-0 w-64 h-full bg-navy text-white p-4 transform transition-transform duration-300 ease-in-out ${isMenuOpen ? "translate-x-0" : "translate-x-full"
                        } sm:hidden`}
                >
                    <button
                        className="text-xl absolute top-4 right-4"
                        onClick={handleMenuClose}
                    >
                        ×
                    </button>
                    <ul className="space-y-4 pt-6">
                        <li>
                            <Link
                                to="hero"
                                smooth={true}
                                duration={500}
                                className="hover:underline cursor-pointer"
                                onClick={() => {
                                    handleMenuClose();
                                }}
                            >
                                Home
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="features"
                                smooth={true}
                                duration={500}
                                className="hover:underline cursor-pointer"
                                onClick={() => {
                                    handleMenuClose();
                                }}
                            >
                                Features
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="contact"
                                smooth={true}
                                duration={500}
                                className="hover:underline cursor-pointer"
                                onClick={() => {
                                    handleMenuClose();
                                }}
                            >
                                Contact Us
                            </Link>
                        </li>
                        <li>
                            <label
                                onClick={() => {
                                    openModal();
                                    handleMenuClose(); // Close the menu after opening the modal
                                }}
                                className="hover:underline cursor-pointer"
                            >
                                Request Demo
                            </label>
                        </li>
                    </ul>
                </div>

                {/* Navigation Links for larger screens */}
                <ul className="sm:flex sm:space-x-6 space-y-4 sm:space-y-0 sm:items-center hidden">
                    <li>
                        <Link
                            to="hero"
                            smooth={true}
                            duration={500}
                            className="hover:underline cursor-pointer"
                        >
                            Home
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="features"
                            smooth={true}
                            duration={500}
                            className="hover:underline cursor-pointer"
                        >
                            Features
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="contact"
                            smooth={true}
                            duration={500}
                            className="hover:underline cursor-pointer"
                        >
                            Contact Us
                        </Link>
                    </li>
                    <li>
                        <button
                            onClick={openModal}
                            className="bg-blue-600 px-4 py-2 rounded hover:bg-blue-700"
                        >
                            Request Demo
                        </button>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default Navbar;
